import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from '../services/toastr.service';
import { ApiErrorResponse } from '../models/auth.model';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loading = false;
  showPassword = false;

  form: FormGroup<{ username: FormControl<string | null>; password: FormControl<string | null> }>;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;

    const { username, password } = this.form.getRawValue();

    this.authService.login({ username: username!, password: password! }).subscribe({
      next: () => this.router.navigate(['/']),
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.toastrService.error(this.resolveErrorMessage(err));
      }
    });
  }

  /** SSO sign-in is not wired up yet — button is present for layout only. */
  loginWithSso(): void {
  }

  private resolveErrorMessage(err: HttpErrorResponse): string {
    const body = err.error as ApiErrorResponse | undefined;

    if (body?.detail) {
      return body.detail;
    }
    if (body?.error?.message) {
      return body.error.message;
    }
    if (err.status === 401) {
      return 'Invalid username or password.';
    }
    return 'Something went wrong. Please try again.';
  }
}
